/**
 * Complete reference for placeholders & session variables (v2 flow).
 * Shown in UI guide + docs. Runtime resolves these in waba_webhook FlowEngine.
 */

/** Always available — customer / WhatsApp context */
export const CONTACT_VARS = [
  {
    token: '{{contact.wa_id}}',
    name: 'wa_id',
    group: 'contact',
    description: 'Customer WhatsApp number (E.164 without + in storage)',
    example: '919876543210',
    usedIn: ['API URL', 'Template params', 'External APIs'],
  },
  {
    token: '{{contact.name}}',
    name: 'name',
    group: 'contact',
    description: 'Profile name from WhatsApp',
    example: 'Rahul',
    usedIn: ['Message body', 'API URL'],
  },
];

/**
 * Session variables — name is defined in YOUR flow (not fixed).
 * Token format is always {{vars.<name>}}.
 */
export const COMMON_SESSION_VARS = [
  {
    name: 'otp',
    token: '{{vars.otp}}',
    setBy: 'logic.ask + logic.validate',
    description: 'OTP entered by customer',
    exampleFlow: 'Ask → Validate → API verify',
  },
  {
    name: 'token',
    token: '{{vars.token}}',
    setBy: 'integration.api → save_from_api',
    description: 'Bearer / access token from auth API',
    exampleFlow: 'API auth → use_token on next APIs',
  },
  {
    name: 'branch',
    token: '{{vars.branch}}',
    setBy: 'logic.set_var (template button)',
    description: 'inquiry | buy — route after product pick',
    exampleFlow: 'Template buttons → route_by_var',
  },
  {
    name: 'category_id',
    token: '{{vars.category_id}}',
    setBy: 'message.list_dynamic (var_on_select)',
    description: 'Selected category from list',
    exampleFlow: 'Categories API → list → products API',
  },
  {
    name: 'product_id',
    token: '{{vars.product_id}}',
    setBy: 'message.list_dynamic (var_on_select)',
    description: 'Selected product from list',
    exampleFlow: 'Products API → list → order',
  },
  {
    name: 'qty',
    token: '{{vars.qty}}',
    setBy: 'logic.ask',
    description: 'Quantity for order',
    exampleFlow: 'Ask QTY → place order API',
  },
  {
    name: 'client_id',
    token: '{{vars.client_id}}',
    setBy: 'integration.api → save_from_api',
    description: 'CRM / banking client id after verify',
    exampleFlow: 'Verify API → downstream APIs',
  },
];

/** Last API response — for conditions & dynamic lists (not vars.*) */
export const API_RESPONSE_PATHS = [
  {
    token: '{{api.last.success}}',
    path: 'success',
    description: 'Top-level key from last API JSON (condition node)',
    usedIn: ['logic.condition'],
  },
  {
    token: '{{api.last.data.token}}',
    path: 'data.token',
    description: 'Nested path — example; use your real JSON shape',
    usedIn: ['Conditions', 'Debug'],
  },
  {
    token: 'last_api_response (config)',
    path: 'N/A',
    description: 'list_dynamic: items_var = array in session vars; value_field / label_field on each item',
    usedIn: ['message.list_dynamic'],
  },
];

/** Legacy aliases — do NOT show in UI chips; map for migration docs only */
export const LEGACY_ALIASES = [
  { old: '#number', use: '{{contact.wa_id}}' },
  { old: ':otp', use: '{{vars.otp}}' },
  { old: 'WAITING_FOR_OTP', use: 'logic.ask node (var: otp)' },
  { old: 'VERIFY_OTP', use: 'integration.api node' },
];

/** Rules shown in UI */
export const VAR_RULES = [
  'Session vars use {{vars.name}} — name comes from Ask / Set var / save_from_api.',
  'Contact fields are always {{contact.wa_id}} and {{contact.name}}.',
  'Bearer auth uses use_token: "token" meaning vars.token (var name, not the word "token" only).',
  'Conditions on API: source last_api_response, path success, operator equals.',
  'Never use WAITING_FOR_*, VERIFY_*, INITIAL in new flows.',
];
